import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Text,
} from '@shared/ui';

export function TabsShowcase() {
  const { t } = useTranslation();
  const [secondarySize, setSecondarySize] = useState<'default' | 'compact'>('default');

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.navigation.tabs.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.navigation.tabs.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="courses" className="w-full">
          <TabsList variant="primary">
            <TabsTrigger variant="primary" value="courses">
              {t('uiLibrary.navigation.tabs.items.courses')}
            </TabsTrigger>
            <TabsTrigger variant="primary" value="registrations">
              {t('uiLibrary.navigation.tabs.items.registrations')}
            </TabsTrigger>
            <TabsTrigger variant="primary" value="students">
              {t('uiLibrary.navigation.tabs.items.students')}
            </TabsTrigger>
            <TabsTrigger variant="primary" value="materials">
              {t('uiLibrary.navigation.tabs.items.materials')}
            </TabsTrigger>
          </TabsList>
          <TabsContent value="courses" className="mt-4">
            <Text size="sm" color="muted">
              {t('uiLibrary.navigation.tabs.content.primary')}
            </Text>
          </TabsContent>
          <TabsContent value="registrations" className="mt-4">
            <Text size="sm" color="muted">
              {t('uiLibrary.navigation.tabs.content.primary')}
            </Text>
          </TabsContent>
          <TabsContent value="students" className="mt-4">
            <Text size="sm" color="muted">
              {t('uiLibrary.navigation.tabs.content.primary')}
            </Text>
          </TabsContent>
          <TabsContent value="materials" className="mt-4">
            <Text size="sm" color="muted">
              {t('uiLibrary.navigation.tabs.content.primary')}
            </Text>
          </TabsContent>
        </Tabs>

        <div className="mt-6">
          <div className="mb-2 flex gap-2" role="group" aria-label="Tabs size">
            {(['default', 'compact'] as const).map((size) => (
              <Button
                key={size}
                size="sm"
                variant={secondarySize === size ? 'default' : 'outline'}
                aria-pressed={secondarySize === size}
                onClick={() => {
                  setSecondarySize(size);
                }}
              >
                <code>{`size="${size}"`}</code>
              </Button>
            ))}
          </div>
          <Tabs defaultValue="open" className="w-full">
            <TabsList variant="secondary" className="overflow-x-auto overflow-y-hidden">
              <TabsTrigger variant="secondary" size={secondarySize} value="open" className="ml-0">
                {t('uiLibrary.navigation.tabs.items.openCourses')}
              </TabsTrigger>
              <TabsTrigger variant="secondary" size={secondarySize} value="past" className="-ml-px">
                {t('uiLibrary.navigation.tabs.items.pastCourses')}
              </TabsTrigger>
              <TabsTrigger
                variant="secondary"
                size={secondarySize}
                value="calendar"
                className="-ml-px"
              >
                {t('uiLibrary.navigation.tabs.items.calendar')}
              </TabsTrigger>
            </TabsList>
            <TabsContent value="open" className="mt-4">
              <Text size="sm" color="muted">
                {t('uiLibrary.navigation.tabs.content.secondary')}
              </Text>
            </TabsContent>
            <TabsContent value="past" className="mt-4">
              <Text size="sm" color="muted">
                {t('uiLibrary.navigation.tabs.content.secondary')}
              </Text>
            </TabsContent>
            <TabsContent value="calendar" className="mt-4">
              <Text size="sm" color="muted">
                {t('uiLibrary.navigation.tabs.content.secondary')}
              </Text>
            </TabsContent>
          </Tabs>
        </div>

        <div className="mt-6">
          <Tabs defaultValue="courses" className="w-full">
            <TabsList variant="header">
              <TabsTrigger variant="header" value="courses">
                {t('navigation.courses')}
              </TabsTrigger>
              <TabsTrigger variant="header" value="instructors">
                {t('navigation.forInstructors')}
              </TabsTrigger>
              <TabsTrigger variant="header" value="students">
                {t('navigation.forStudents')}
              </TabsTrigger>
            </TabsList>
            <TabsContent value="courses" className="mt-4">
              <Text size="sm" color="muted">
                {t('uiLibrary.navigation.tabs.content.header')}
              </Text>
            </TabsContent>
            <TabsContent value="instructors" className="mt-4">
              <Text size="sm" color="muted">
                {t('uiLibrary.navigation.tabs.content.header')}
              </Text>
            </TabsContent>
            <TabsContent value="students" className="mt-4">
              <Text size="sm" color="muted">
                {t('uiLibrary.navigation.tabs.content.header')}
              </Text>
            </TabsContent>
          </Tabs>
        </div>
      </CardContent>
    </Card>
  );
}
